// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.O3gyF{display:flex;flex-direction:column;gap:4px;align-items:center;width:100%}.O3gyF .VpiGS{width:100%;min-height:120px}.O3gyF .VpiGS.ntnjK{border-color:#dd4c4c}.O3gyF .VpiGS .PbPqk{position:absolute;width:100%;height:100%;align-items:center;justify-content:center;background-color:#f4f4f7;z-index:999;pointer-events:none;display:none;animation:cN6R4 .2s ease-in-out}.O3gyF .VpiGS .PbPqk *{pointer-events:none}.O3gyF .VpiGS .PbPqk.B8OQe{display:flex;animation:wzdJV .2s ease-in-out}.O3gyF .VpiGS .Qu34J{width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;transition:background-color .2s ease,border-color .2s ease}.O3gyF .VpiGS .Qu34J:hover{background-color:#f4f4f7}.My7Er{margin-top:8px;align-self:flex-end}.My7Er .JTot5{text-decoration:none}.My7Er .JTot5:hover{text-decoration:underline}@keyframes wzdJV{from{opacity:0}to{opacity:1}}@keyframes cN6R4{from{opacity:1;display:flex}99%{opacity:0;display:flex}to{opacity:0;display:none}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"uploadContainerWrapper": `O3gyF`,
	"uploadContainer": `VpiGS`,
	"error": `ntnjK`,
	"uploadContainerDragging": `PbPqk`,
	"fadeOut": `cN6R4`,
	"display": `B8OQe`,
	"fadeIn": `wzdJV`,
	"uploadContainerContent": `Qu34J`,
	"downloadExample": `My7Er`,
	"downloadLink": `JTot5`
};
export default ___CSS_LOADER_EXPORT___;
